/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Operations_Src_1_DetailInputs */

const en_wb_operations_src_1_detail = /** @type {(inputs: Wb_Operations_Src_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items and quantity extracted`)
};

const lv_wb_operations_src_1_detail = /** @type {(inputs: Wb_Operations_Src_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preces un daudzums iegūti`)
};

/**
* | output |
* | --- |
* | "Items and quantity extracted" |
*
* @param {Wb_Operations_Src_1_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_operations_src_1_detail = /** @type {((inputs?: Wb_Operations_Src_1_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Operations_Src_1_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_operations_src_1_detail(inputs)
	return en_wb_operations_src_1_detail(inputs)
});